export class Navegador  {

     // Informa se o navegador do usuário é o IE 
     public static ehInternetExplorer() : boolean {
      const agent = window.navigator.userAgent.toLowerCase()
  
      // Microsoft Internet Explorer
      if(agent.indexOf('trident') > -1)
      return true;
  
      return false;
     }
  
       // Informa se o navegador do usuário é o Edge
    public static ehEdge() : boolean {
      const agent = window.navigator.userAgent.toLowerCase()
  
      // Microsoft Edge
      if(agent.indexOf('edge') > -1)
        return true;
        
      return false;
     }
  
    // Informa se o navegador do usuário é o Firefox
    public static ehFirefox() : boolean {
      const agent = window.navigator.userAgent.toLowerCase()
  
      // Mozilla Firefox
      if(agent.indexOf('firefox') > -1)
        return true;
        
      return false;
     }

     // Identifica se o navegador é mobile
     public static ehNavegadorMobile() : boolean {

        // Primeira Etapa: Identificação pelo SO do browser
        const mobileAgent = window.navigator.userAgent;
        const mobileSoPatterns = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;

        const possuiMobileAgent = mobileSoPatterns.test(mobileAgent);

        if(possuiMobileAgent) 
            return true;

         // Segunda Etapa: Verifica se o layout é compatível com Mobile, o valor apresentado abaixo é um breakpoint comum para mobile
        const layoutMobile =  window.matchMedia("(max-width: 767px)").matches;

        if(layoutMobile)
          return true;

        // Terceira Etapa: Verifica o número máximo de toques simultanêos suportado pelo dispositivo
        // Browsers mais modernos provem essa propriedade, e um valor maior que 0 indica touch-enabled device 
        // que é geralmente caracteristico de dispositivos móveis, incluindo celular e tablet
        const numeroMaximoToqueSimultaneo =  window.navigator.maxTouchPoints > 0

        if(numeroMaximoToqueSimultaneo)
          return true;

        return false;   
     }
  }


// WEBPACK FOOTER //
// ./src/app/shared/navegador/navegador.ts